import React from 'react';
import './ConsultaImoveis.css';

var STATUS_CORES = {
  bloqueado: '#000000',
  vendido: '#FF0000',
  carteira: '#800000',
  reservado: '#FF8000',
  pre_venda: '#0000FF',
  alugado: '#00FF80',
  proposta_rapida: '#FFFF00',
  disponivel: '#008000',
  sem_tabela: '#FF00FF',
  repasse: '#C0DCC0',
  reserva_especial: '#400000',
  reserva_casa: '#F08080',
};

// Mesma cascata do Delphi (BitBtn3Click linhas 1100-1189). Retorna a chave
// de categoria usada na legenda (LegendaContadores.ITENS_LEGENDA).
var getStatusKey = (imovel) => {
  if (imovel.status === 'B') return 'bloqueado';
  if (imovel.status === 'V') {
    if (!imovel.boleto || imovel.boleto === 0) return 'carteira';
    var isCarteira = imovel.carteira === 0
      || imovel.boleto === imovel.rescisao
      || (imovel.cancelado && imovel.cancelado > imovel.boleto);
    if (isCarteira) return 'carteira';
    return 'vendido';
  }
  if (imovel.status === 'R') return 'reservado';
  if (imovel.status === 'P') return 'pre_venda';
  if (imovel.status === 'A') return 'alugado';
  if (imovel.status === 'O') return 'proposta_rapida';
  // Status D — cascata
  if (imovel.data_tabela_preco && imovel.data_ultima_operacao
    && new Date(imovel.data_tabela_preco) < new Date(imovel.data_ultima_operacao))
    return 'sem_tabela';
  if (imovel.tem_repasse === 1) return 'repasse';
  if (imovel.tem_reserva_especial === 1) return 'reserva_especial';
  if (imovel.tem_reserva_casa === 1) return 'reserva_casa';
  return 'disponivel';
};

var getCorStatus = (imovel) => STATUS_CORES[getStatusKey(imovel)];

var coresEscuras = [
  STATUS_CORES.bloqueado,
  STATUS_CORES.vendido,
  STATUS_CORES.carteira,
  STATUS_CORES.reservado,
  STATUS_CORES.pre_venda,
  STATUS_CORES.reserva_especial,
  STATUS_CORES.disponivel,
];

var getCorTexto = (cor) => {
  if (coresEscuras.indexOf(cor) !== -1) return '#ffffff';
  return '#000000';
};

var agruparPorQuadra = (imoveis) => {
  var grupos = {};
  var ordem = [];
  imoveis.forEach((imovel) => {
    var quadra = imovel.mapa1 || '(sem quadra)';
    if (!grupos[quadra]) {
      grupos[quadra] = [];
      ordem.push(quadra);
    }
    grupos[quadra].push(imovel);
  });
  return { grupos, ordem };
};

var GradeQuadraLote = ({
  imoveis,
  onLoteDoubleClick,
  onLoteContextMenu,
  onLoteClick,
  loading,
  filtrosStatus,
}) => {
  var filtros = filtrosStatus || [];
  var temFiltro = filtros.length > 0;
  if (loading) {
    return (
      <div className="text-center p-4">
        <span>Carregando mapa...</span>
      </div>
    );
  }

  if (!imoveis || imoveis.length === 0) {
    return (
      <div className="text-center p-4 text-muted">
        Selecione um empreendimento e clique em Buscar.
      </div>
    );
  }

  var agrupamento = agruparPorQuadra(imoveis);
  var grupos = agrupamento.grupos;
  var ordem = agrupamento.ordem;

  return (
    <div className="grade-quadra-lote p-2">
      {ordem.map((quadra) => (
        <div key={quadra} className="quadra-row mb-1">
          <div className="quadra-label">{quadra}</div>
          <div className="lotes-row">
            {grupos[quadra].map((imovel) => {
              var statusKey = getStatusKey(imovel);
              var cor = STATUS_CORES[statusKey];
              var corTexto = getCorTexto(cor);
              var texto = imovel.mapa2 || '';
              if (imovel.extra === '*') texto = texto + '*';
              var foraDoFiltro = temFiltro && filtros.indexOf(statusKey) === -1;
              return (
                <div
                  key={`${imovel.mapa1}-${imovel.mapa2}-${imovel.codigo_ativo}`}
                  className={`lote-cell${foraDoFiltro ? ' lote-fora-filtro' : ''}`}
                  style={{ backgroundColor: cor, color: corTexto }}
                  title={`Quadra: ${imovel.mapa1} | Lote: ${imovel.mapa2} | Status: ${imovel.status}`}
                  onClick={(e) => {
                    if ((e.shiftKey || e.ctrlKey) && onLoteClick) {
                      onLoteClick(e, imovel);
                    }
                  }}
                  onDoubleClick={() => onLoteDoubleClick && onLoteDoubleClick(imovel)}
                  onContextMenu={(e) => {
                    e.preventDefault();
                    onLoteContextMenu && onLoteContextMenu(e, imovel);
                  }}
                >
                  {texto}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default GradeQuadraLote;
export { getStatusKey, getCorStatus };
